<template>
  <div>
    <div class="title">
      {{ getLabelCode('common.event.time') ?? $t('date-title') }}
    </div>
    <div class="date-box">
      <a-button
        :class="{
          'card-button': true,
          'active': choosePerfId === item.performanceId,
          'readonly': readonly
        }"
        v-for="item in dateList"
        :key="item.performanceId"
        @click="clickDate(item)"
        :disabled="readonly || item.status === Object.keys(limitObj)[2]"
      >
        <div class="date-box-left" v-if="item.performanceDate">
          <div class="monthYear">
            {{
              `${getMonth(new Date(item.performanceDate))}，${new Date(
                item.performanceDate
              ).getFullYear()}`
            }}
          </div>
          <div class="day">{{ new Date(item.performanceDate).getDate() }}</div>
        </div>
        <div class="date-box-right">
          <div class="weekTime"  v-if="item.performanceDate">
            {{
              `${getWeek(new Date(item.performanceDate))}，${padStart(
                new Date(item.performanceDate).getHours(),
                2,
                0
              )}:${padStart(new Date(item.performanceDate).getMinutes(), 2, 0)}`
            }}
          </div>
          <div class="name" v-html="getName(item, 'performanceName')"></div>
          <div class="limited" v-if="limitObj[item.status]">
            <img
              src="@/assets/images/limited.svg"
              :alt="$t(limitObj[item.status])"
            />
            {{ $t(limitObj[item.status]) }}
          </div>
        </div>
      </a-button>
    </div>
  </div>
</template>

<script>
import { getUtsvField, padStart } from '@/utils/utils'
import { mapGetters } from 'vuex'
export default {
  props: {
    dateList: {
      type: Array,
      default: () => []
    },
    limitObj: {
      type: Object,
      required: true
    },
    defaultDateId: {
      type: Number,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nMonthField: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'Nov', 'Dec'],
      i18nWeekField: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
      choosePerfId: this.defaultDateId
    }
  },
  watch: {
    defaultDateId (val) {
      this.choosePerfId = val
    }
  },
  computed: {
    ...mapGetters(['getLabelCode']),
    getMonth () {
      return (date) => {
        return this.$t(`month-title-${this.i18nMonthField[date.getMonth()]}`)
      }
    },
    getWeek () {
      return (date) => {
        return this.$t(`week-title-${this.i18nWeekField[date.getDay()]}`)
      }
    },
    getName () {
      return (obj, name) => {
        return obj ? getUtsvField(obj, name, this.$i18n.locale) : ''
      }
    }
  },
  methods: {
    clickDate (item) {
      this.choosePerfId = item.performanceId
      this.$emit('clickDate', item)
    },
    padStart
  }
}
</script>

<style lang="scss" scoped>
.title,
.date-box {
  padding: 0 5px;
  @media (max-width: 991px) {
    padding: 0;
  }
}
.title {
  color: $theme-color;
  font-size: 1.3125rem;
  font-weight: 700;
}

.card-button {
  width: 100%;
  height: auto;
  margin: 0.625rem 0;
  padding: 6px;
  display: flex;
  border: 0.125rem solid #ced4da;
  font-size: 1.3125rem;
  background-color: transparent;

  &.readonly:hover {
    background-color: transparent;
  }

  &:not(.readonly) {
    border-color: $theme-color;
  }

  &:not(.readonly):hover {
    border-color: $theme-color-hover;
    @include background_color('detail-buy_background-active');
    .day, .name {
      color: #272d4e !important;
    }
  }

  &:focus {
    box-shadow: 0 0 0 0.2rem rgba($theme-color-hover, 0.5);
  }

  &.active {
    @include background_color('detail-buy_background-active');
    .day, .name {
      color: #272d4e !important;
    }
  }
  &:disabled {
    opacity: 0.65;
  }
  &.readonly:disabled {
    opacity: 1;
    cursor: revert;
  }
}

.date-box {
  max-height: 20.625rem;
  overflow-y: auto;
  margin-bottom: 30px;
}

.date-box-left {
  text-align: center;
  margin-right: 0.5rem;
  padding: 0 5px;
  line-height: 2rem;

  .monthYear {
    color: $theme-color;
    font-size: 1rem;
  }

  .day {
    font-size: 1.875rem;
    @include font_color('detail-buy_day');
  }
}

.date-box-right {
  width: 100%;
  text-align: left;
  position: relative;

  .weekTime {
    color: $theme-color;
    @media (min-width: 80rem) {
      font-size: 1.3125rem;
    }
    font-size: 1.1875rem;
  }

  .name {
    margin-top: 5px;
    white-space: initial;
    @media (min-width: 100rem) {
      font-size: 1.125rem;
    }
    @media (min-width: 80rem) {
      font-size: 1rem;
    }
    font-size: 0.875rem;
    @include font_color('detail-title');
  }
}

.limited {
  position: absolute;
  top: 0.3rem;
  right: 0.5rem;
  background: #f2c94c;
  padding: 0 0.3125rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  color: #000;
  display: flex;
  align-items: center;
  img {
    display: block;
    margin-right: 2px;
    max-width: 0.875rem;
  }
}
</style>
